import React from 'react';

type Propstype = {
  children: React.ReactNode;
  className?: string;
};

export const Body = ({ children, className = '', ...props }: Propstype) => {
  const tw = {
    body: 'text-base leading-6 text-gray-900',
  };
  return (
    <p {...props} className={tw.body + ' ' + className}>
      {children}
    </p>
  );
};
